export default __webpack_public_path__ + "css/forgotPassword.bundle.css";